import React from 'react';
import { Form } from 'react-bootstrap';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
const ReviewerActionForm = _ref => {
  let {
    reviewerComments,
    setReviewerComments,
    onInitialAndClose,
    onRequireClarification,
    loading
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-3 border-top"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "small"
  }, /*#__PURE__*/React.createElement("strong", null, "Reviewer Comments")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 3,
    value: reviewerComments,
    onChange: e => setReviewerComments(e.target.value),
    placeholder: "Enter reviewer comments..."
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 justify-content-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    size: "sm",
    onClick: onInitialAndClose,
    disabled: loading,
    text: "Initial and Close",
    variant: "success"
  }), /*#__PURE__*/React.createElement(SaveButton, {
    size: "sm",
    onClick: onRequireClarification,
    disabled: loading || !reviewerComments.trim(),
    text: "Requires Clarification",
    variant: "danger"
  })));
};
export default ReviewerActionForm;